const LocalStorageKeys = {
  SELECTED_TAB: "SelectedTab",
  AUTHORIZATION_KEY: "Authorization",
  ARTICLE_ID: "ArticleId",
  NEWS_ID: "NewsId",
  USER_DETAILS: "UserDetails",
}

export default LocalStorageKeys;
